var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        viewBox: "0 0 200 200",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      }
    },
    [
      _c("rect", {
        attrs: {
          fill: "var(--initar-bg, #000)",
          x: "0",
          y: "0",
          width: "200",
          height: "200"
        }
      }),
      _vm._v(" "),
      _c(
        "text",
        {
          attrs: {
            "font-family":
              "var(--initar-font, Helvetica Neue, Helvetica, Arial, sans-serif)",
            "font-size": "80",
            "font-weight": "var(--initar-font-weight, bold)",
            fill: "var(--initar-fg, #fff)",
            "text-anchor": "middle",
            "dominant-baseline": "middle",
            y: "50%",
            x: "50%"
          }
        },
        [_vm._v(_vm._s(_vm.initials.toUpperCase()))]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }